import { load } from './lib/_load.js';
import { object } from './lib/_obj.js';
import { setting } from './lib/_setting.js';
let $html 		= document.documentElement;
let modalData = {
	count: 0,
	max: 0,
	inc: function(){
		let $this = modalData;
		$this.count++;
		if($this.count >= $this.max){
			$this.count = 0;
		}
		document.querySelector("#modal_nft").classList.add("disable");
		setTimeout(function(){
			collection.changeDetail().then( () => {
				collection.openModal();
			});
		}, 200);
	},
	dec: function(){
		let $this = modalData;
		$this.count--;
		if($this.count < 0){
			$this.count = $this.max - 1;
		}
		document.querySelector("#modal_nft").classList.add("disable");
		setTimeout(function(){
			collection.changeDetail().then( () => {
				collection.openModal();
			});
		}, 200);
	}
}
export let collection = {
	jsonURL: "/jlc/listenplus/app/get_owned_nfts.json",
	lists: {},
	normal: [],
	special: [],
	currentData: [],
	isSpecialPage: false,
	currentYear: 0,
	myAddress: "",
	normalLength: 0,
	specialLength: 0,
	modalVideo: null,
	init: function(page){
		if(page.pathArry[page.pathArry.length-2] === "special"){
			collection.isSpecialPage = true;
		}else{
			collection.isSpecialPage = false;
		}
		let $body = document.querySelector("body");
		let apiURL = this.jsonURL;
		if(location.hostname.includes("kentaromi.tokyo") || location.hostname.includes("macbook-pro.local")){
			
		}else{
			apiURL = setting.nft;
			if( $body.classList.contains("disable") ){
				document.querySelector("body").classList.remove("disable");
			}
		}
		//console.log("is Special: ", collection.isSpecialPage);
		
		//console.log(apiURL);
		//console.log(apiURL);
		load.getJson(apiURL, {}).then( (res) => {
			//res.contract_address = "1"; //テスト用
			//console.log(res);
			if(res.data.nfts.contract_address === ""){
				//location.href = "/jlc/listenplus/app/";
				document.querySelector("body").classList.add("not_connected");
				/*
				let $connectBtn = document.querySelector("#btn_unwallet");
				$connectBtn.addEventListener("click", collection.openUnwallet, false);
				console.log("no connection");
				*/
			}else{
				collection.myAddress = res.data.nfts.contract_address;
				document.querySelector("body").classList.add("connected");
				//console.log(res);
				collection.lists = res.data.nfts.collection;
				//console.table(collection.lists);
				if(collection.lists.length > 0){
					collection.filterData();
					let now = new Date();
					let year = now.getFullYear();
					collection.makeList(year);
				}else{
					document.querySelector("body").classList.add("no_nfts");
				}
			}
			if( $body.classList.contains("disable") ){
				setTimeout(function(){
					document.querySelector("body").classList.remove("disable");
				}, 200);
			}
		});
	},
	filterData: function(){
		let specials 	= [];
		let normals 	= [];
		//console.log(collection.lists.collection)
		for(let i = 0; i < collection.lists.length; i++){
			let d = collection.lists[i];
			if(d.special === "1"){
				specials.push(d);
			}else if(d.special === "0"){
				normals.push(d);
			}
		}
		//console.log(normals, specials);
		/* normal / specialを年別にわける -----------------------------------*/
		let beforeYear = 0;
		let YearObj = {
			year: 0,
			collection: []
		}
		let yobj = {};
		collection.normal = [];
		collection.normalLength = normals.length;
		
		for(let n = 0; n < normals.length; n++){
			let data = normals[n];
			let date = data.date;
			let dateArry = date.split("/");
			let year = parseInt( dateArry[0] );
			if( year === beforeYear){
				yobj.collection.push(data);
			}else{
				if(n > 0){
					collection.normal.push(yobj);
				}
				yobj = object(YearObj);
				yobj.year = year;
				yobj.collection = [];
				yobj.collection.push(data);
			}
			if(n === normals.length - 1){
				collection.normal.push(yobj);
			}
			beforeYear = year;
		}
		//console.log("normals: ", normals);
		//console.log("normal:", collection.normal);
		yobj = {};
		beforeYear = 0;
		collection.special = [];
		collection.specialLength = specials.length;
		for(let s = 0; s < specials.length; s++){
			let data = specials[s];
			let date = data.date;
			let dateArry = date.split("/");
			let year = parseInt( dateArry[0] );
			if( year === beforeYear){
				yobj.collection.push(data);
				
			}else{
				if(s > 0){
					collection.special.push(yobj);
				}
				yobj = object(YearObj);
				yobj.year = year;
				yobj.collection = [];
				yobj.collection.push(data);
			}
			if(s === specials.length - 1){
				collection.special.push(yobj);
			}
			beforeYear = year;
		}
		if(collection.isSpecialPage){
			document.querySelector(".total_nft").innerHTML = collection.specialLength;
			if(collection.special.length === 1){
				removePager();
			}
		}else{
			document.querySelector(".total_nft").innerHTML = collection.normalLength;
			if(collection.normal.length === 1){
				removePager();
			}
		}
		function removePager(){
			document.querySelector("#modal_nft a.btn_prev").remove();
			document.querySelector("#modal_nft a.btn_next").remove();
		}
		console.log(collection.special, collection.normal);
		//console.log(specials, normals);
	},
	makeList: function(year){
		//console.log("makeList:", year);
		let HTML = "";
		let data = [];
		if(collection.isSpecialPage){
			data = collection.special;
		}else{
			data = collection.normal;
		}
		
		let currentYearData = [];
		let navHTML = "";
		for(let i = 0; i < data.length; i++){
			if( data[i].year === year ){
				currentYearData = data[i];
				collection.currentData = currentYearData;
				navHTML += `<option value="${data[i].year}" selected>${data[i].year}</option>`
			}else{
				navHTML += `<option value="${data[i].year}">${data[i].year}</option>`;
			}
		}
		document.querySelector("#select_year").innerHTML = navHTML;
		//console.log(currentYearData);
		let listHTML = ``;
		for(let j = 0; j < currentYearData.collection.length; j++){
			let d = currentYearData.collection[j];
			//console.log(d);
			let names = d.metadata.name.split("#");
			
			listHTML += `<li>
							<a href="javascript:void(0);" data-id="${j}">
								<figure>
									<img src="${d.metadata.image}" alt="${d.metadata.name}">
								</figure>
								<div class="txt">
									<h3>${names[0]}</h3>
									<p>#${names[1]}</p>
								</div>
							</a>
						</li>`
		}
		document.querySelector("#list_nft ul").innerHTML = listHTML;
		document.querySelector("#modal_nft .modal_inner").scrollTop = 0;
		modalData.max = currentYearData.collection.length;
		collection.nav();
	},
	nav: function(){
		let $nfts = document.querySelectorAll("#list_nft ul li a");
		$nfts.forEach( ($nft) => {
			$nft.removeEventListener("click", collection.getDetail, false);
			$nft.addEventListener("click", collection.getDetail, false);
		});
		let $closes = document.querySelectorAll("[data-close-nft]");
		$closes.forEach( ($close) => {
			$close.removeEventListener("click", collection.closeModal, false);
			$close.addEventListener("click", collection.closeModal, false);
		});
		let $btnPrev = document.querySelector("#modal_nft a.btn_prev");
		let $btnNext = document.querySelector("#modal_nft a.btn_next");
		if($btnPrev){
			$btnPrev.removeEventListener("click", modalData.dec, false);
			$btnPrev.addEventListener("click", modalData.dec, false);
		}
		
		if($btnNext){
			$btnNext.removeEventListener("click", modalData.inc, false);
			$btnNext.addEventListener("click", modalData.inc, false);
		}
		
		//
		let $select = document.querySelector("select#select_year");
		$select.removeEventListener("change", collection.changeYear, false);
		$select.addEventListener("change", collection.changeYear, false);
	},
	getDetail: function(){
		let idx = this.getAttribute("data-id");
		modalData.count = parseInt(idx);
		collection.changeDetail().then( () => {
			collection.openModal();
		});
	},
	changeDetail: function(){
		let $this = this;
		return new Promise((resolve, reject) => {
			let data = collection.currentData.collection[modalData.count];
			console.log(data);
			let name 		= data.metadata.name;
			let nameArry 	= name.split("#");
			let date 		= data.date;
			let dateArry 	= date.split("/");
			let $modal 		= document.querySelector("#modal_nft");
			$modal.querySelector(".serial dl dd").innerHTML = "#" + nameArry[1];
			$modal.querySelector("span.get_year").innerHTML = dateArry[0];
			$modal.querySelector("span.get_month").innerHTML = dateArry[1];
			$modal.querySelector("video").setAttribute("src", data.metadata.animation_url);
			$modal.querySelector("video").setAttribute("poster", data.metadata.image);
			$modal.querySelector(".description p").innerHTML = data.metadata.description;
			$modal.querySelector(".token dd").innerHTML = data.id;
			$modal.querySelector(".address dd span").innerHTML = collection.myAddress;
			if(collection.isSpecialPage){
				$modal.querySelector(".date_get p span").innerHTML = date;
			}
			resolve();
		});
	},
	openModal: function(){
		if( !$html.classList.contains("show_nft_modal") ){
			document.querySelector("#modal_nft .modal_inner").scrollTop = 0;
			$html.classList.add("show_nft_modal");
			collection.modalVideo = document.querySelector("#modal_nft video");
			collection.modalVideo.play();
			collection.nav();
		}else{
			document.querySelector("#modal_nft").classList.remove("disable");
			collection.nav();
		}
	},
	closeModal: function(){
		if( $html.classList.contains("show_nft_modal") ){
			$html.classList.remove("show_nft_modal");
			collection.modalVideo.pause();
		}
	},
	openUnwallet(){
		//document.querySelector("body").classList.add("clicked_connect");
	},
	changeYear: function(){
		let year = this.options[this.selectedIndex].value;
		
		collection.makeList( parseInt(year) );
	}
}